import React from 'react'

import { useTranslation } from 'language/translator'

import Alert from 'components_new/atoms/Alert'
import { IconName } from 'components_new/atoms/Icon'

import GenericListItem from 'components_new/molecules/GenericListItem'

import MetricsTable from 'components_new/organisms/MetricsTable'

import { TCoreWidgetSettingsLoaded, WidgetType } from 'types/GlobalWidget'

import { hasVariantOptions } from 'utils/variantOptions'

const other: {
  iconName: IconName
  type: WidgetType.TEXT | WidgetType.COMMENT | WidgetType.IMAGE
}[] = [
  {
    iconName: 'StickyNote2Outlined',
    type: WidgetType.COMMENT
  },
  {
    iconName: 'TitleOutlined',
    type: WidgetType.TEXT
  },
  {
    iconName: 'ImageOutlined',
    type: WidgetType.IMAGE
  }
]

export interface SelectMetricProps {
  category: string | null
  handleAddOther?: (
    type: WidgetType.TEXT | WidgetType.COMMENT | WidgetType.IMAGE
  ) => void
  search: string | null
  setSelectedMetric: (metric: string, defaultVariant: string | null) => void
  subcategory: string | null
  widget?: TCoreWidgetSettingsLoaded
  tab: 'metrics' | 'other'
}

export default (props: SelectMetricProps) => {
  const {
    category,
    handleAddOther = () => {},
    search,
    setSelectedMetric,
    subcategory,
    widget,
    tab
  } = props

  const { t, translateEnum } = useTranslation()

  if (tab === 'metrics') {
    return (
      <>
        {widget ? (
          <Alert severity="info" sx={{ mb: 1 }}>
            {hasVariantOptions(widget.settings)
              ? t('metrics', 'metric_variant_option_filter_description')
              : t('metrics', 'metric_combination_filter_description')}
          </Alert>
        ) : null}
        <MetricsTable
          onClickMetric={(id, defaultVariant) =>
            setSelectedMetric(id, defaultVariant)
          }
          widget={widget}
          search={search}
          category={category}
          subcategory={subcategory}
        />
      </>
    )
  }

  return (
    <>
      {other.map((item) => (
        <GenericListItem
          action="add"
          body={translateEnum('widget_types', item.type).summary}
          borderBottom={true}
          icon={{
            name: item.iconName
          }}
          key={item.type}
          onClick={() => handleAddOther(item.type)}
          title={translateEnum('widget_types', item.type).title}
          sx={{ maxHeight: 64 }}
        />
      ))}
    </>
  )
}
